import { render, staticRenderFns } from "./PRow.vue?vue&type=template&id=afd69878&scoped=true"
import script from "./PRow.vue?vue&type=script&lang=ts"
export * from "./PRow.vue?vue&type=script&lang=ts"
import style0 from "./PRow.vue?vue&type=style&index=0&id=afd69878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd69878",
  null
  
)

export default component.exports